export const onElementInteract = (element, callback) => {
  const interactEvents = ['mouseover', 'mousedown', 'touchstart']
  const callbackEvent = eventName => element.addEventListener(eventName, callback)
  interactEvents.forEach(callbackEvent)

  return {
    removeEventListeners() {
      interactEvents.forEach(eventName => {
        element.removeEventListener(eventName, callbackEvent)
      })
    }
  }
}
